<ion-footer class="particulier-footer" [ngStyle]="{ 'display': isKeyboardVisible ? 'none' : 'block' }"  [ngClass]="{ 'keyboard-visible': isKeyboardVisible }">
  <ion-toolbar class="particulier-footer__toolbar">
    <ion-buttons class="particulier-footer__buttons">
      <ion-button
        class="toolbar-button home"
        [ngClass]="{ active: activatedRouteIndex === 0 }"
        (click)="goTo('')"
        ><span class="tab-content">
          <ion-icon [name]="activatedRouteIndex === 0 ? 'home' : 'home-outline'"></ion-icon>
          <span class="tab-label">{{ "PROVIDER.FOOTER.HOME" | translate }}</span>
        </span></ion-button
      >

      <ion-button
        (click)="goTo('messagerie')"
        class="toolbar-button chat"
        [ngClass]="{ active: activatedRouteIndex === 1 }"
        ><span class="tab-content">
          <ion-icon [name]="activatedRouteIndex === 1 ? 'chatbubble' : 'chatbubble-outline'"></ion-icon>
          <span class="tab-label">{{ "PROVIDER.FOOTER.DISCUSSIONS" | translate }}</span>
        </span>
        <span class="tab-badge" *ngIf="undreaded_messages_count > 0">{{
          undreaded_messages_count >= 99 ? "99" : undreaded_messages_count
        }}</span>
      </ion-button>
      <ion-button
        (click)="goTo('track-demands')"
        class="toolbar-button save"
        [ngClass]="{ active: activatedRouteIndex === 3 }"
        ><span class="tab-content">
          <ion-icon [name]="activatedRouteIndex === 3 ? 'document-text' : 'document-text-outline'"></ion-icon>
          <span class="tab-label">{{ "PROVIDER.FOOTER.MY_PROFILE" | translate }}</span>
        </span>
        <span class="tab-badge" *ngIf="current_demands_count > 0">{{
          current_demands_count >= 99 ? "99" : current_demands_count
        }}</span></ion-button
      >
      <ion-button
        (click)="goTo('menu')"
        class="toolbar-button user"
        [ngClass]="{ active: activatedRouteIndex === 2 }"
        ><span class="tab-content">
          <ion-icon [name]="activatedRouteIndex === 2 ? 'person' : 'person-outline'"></ion-icon>
          <span class="tab-label">{{ "PROVIDER.FOOTER.PROFILE" | translate }}</span>
        </span></ion-button
      >
    </ion-buttons>
  </ion-toolbar>

</ion-footer>

<!-- confirm meeting modal -->
<ion-modal
  [initialBreakpoint]="1"
  [isOpen]="confirmDemandModal.length"
  [backdropDismiss]="false"
>
  <ng-template>
    <div class="confirm-meeting-modal">
      <app-meeting-demand-modal
        [data]="confirmDemandModal"
      ></app-meeting-demand-modal>
    </div>
  </ng-template>
</ion-modal>

<ion-modal
  [isOpen]="showCancleModal"
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  (ionModalDidDismiss)="handleCancelModal(false)"
  class="confirm-modal-wrapper"
>
  <ng-template>
    <app-cancel-modal
      [description]="'DEVIS_PAGE.CANCEL_MODAL.MESSAGE' | translate"
    >
    </app-cancel-modal>
  </ng-template>
</ion-modal>
<!-- confirm meeting modal -->
<ion-modal
  [initialBreakpoint]="1"
  [isOpen]="newDevis"
  [backdropDismiss]="false"
>
  <ng-template>
    <div class="confirm-devis-modal">
      <div class="devis-demand-modal-wrapper">
        <div class="devis-info">
          <div class="info-container">
            <img
              src="../../../../../assets/img/devis_accepted.svg"
              alt="devis accepted"
            />
            <p>
              {{ "DEVIS_PAGE.NEW_DEVIS_REF" | translate }}
            </p>
          </div>
        </div>
        <div class="buttons-group">
          <app-button
            [innerText]="'RDV_PAGE.CONFIRM_MODAL.CONTINUE_BTN' | translate"
            (onClick)="goToDemand()"
          >
          </app-button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
<ion-modal
  #problemCancelModal
  [isOpen]="problemModal"
  [breakpoints]="[0, 1]"
  (ionModalDidDismiss)="onProblemCancelModalDismiss()"
>
  <ng-template>
    <div class="success-modal">
      <app-devis-succes-modal
        [image]="'provider_2.png'"
        [message]="'DEVIS_PAGE.DEMANDE_SIGNALED' | translate"
        [validText]="'DEVIS_PAGE.RELANCE' | translate"
        [cssClass]="'refuse'"
        [cancleText]="'DEVIS_PAGE.CANCEL' | translate"
        [validLoading]="isRelancing"
        (valid)="validateEndDemande()"
        (cancle)="cancle()"
      ></app-devis-succes-modal>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="addDemandModal" [breakpoints]="[0, 1]">
  <ng-template>
    <div class="add-demand-modal">
      <img
        src="../../../../../assets/img/new_demand_modal.png"
        alt="new demand modal"
      />
      <h2>{{ "DOMAINS_PAGE.MODAL.TITLE" | translate }}</h2>
      <p>{{ "DOMAINS_PAGE.MODAL.MESSAGE" | translate }}</p>
      <div class="buttons">
        <app-button
          [innerText]="'DOMAINS_PAGE.MODAL.ADD_NOW' | translate"
          (onClick)="goTo('domaines-list')"
        >
        </app-button>
        <app-button
          [innerText]="'DOMAINS_PAGE.MODAL.ADD_LATER' | translate"
          (onClick)="handleAddDemandModal(false)"
        >
        </app-button>
      </div>
    </div>
  </ng-template>
</ion-modal>
<!-- openChackPayment -->
<ion-modal
  [isOpen]="openChackPayment"
  [breakpoints]="[0, 1]"
  class="check-payment"
>
  <ng-template class="check-payment-container">
    <app-select-payment-modal></app-select-payment-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [isOpen]="openwithdraw"
  [breakpoints]="[0, 1]"
  class="withdraw_modal"
>
  <ng-template class="check-payment-container">
    <app-withdraw-modal></app-withdraw-modal>
  </ng-template>
</ion-modal>

<app-initial-modal
  [isModalOpen]="attentModalOpen"
  (close)="closeAttentModal()"
  [arrived]="true"
  [confirmLoading]="confirmLoadingArrival"
  [cancelLoading]="cancelLoadingArrival"
  (goToLoaderPage)="sendAcceptation()"
  (notArrived)="notArrived()"
></app-initial-modal>

<ion-modal
  [isOpen]="freeDemand"
  class="first-demand-container"
  [breakpoints]="[0, 1]"
>
  <ng-template>
    <div class="first-demand-modal">
      <app-first-demand></app-first-demand>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="freeDemandClient" [breakpoints]="[0, 1]">
  <ng-template>
    <div class="sent-demand-modal">
      <app-demande-sent></app-demande-sent>
    </div>
  </ng-template>
</ion-modal>
